//Background colors
const breakpoints = {
  xxsMax: 299 / 16 + 'em',
  xxs: 300 / 16 + 'em',
  xsMax: 399 / 16 + 'em',
  xs: 400 / 16 + 'em',
  sMax: 499 / 16 + 'em',
  s: 500 / 16 + 'em',
  smMax: 599 / 16 + 'em',
  sm: 600 / 16 + 'em',
  mMax: 749 / 16 + 'em',
  m: 750 / 16 + 'em',
  lMax: 899 / 16 + 'em',
  l: 900 / 16 + 'em',
  xlMax: 999 / 16 + 'em',
  xl: 1000 / 16 + 'em',
  xxlMax: 1199 / 16 + 'em',
  xxl: 1200 / 16 + 'em',
  xxxlMax: 1399 / 16 + 'em',
  xxxl: 1400 / 16 + 'em'
};

export default breakpoints;



// WEBPACK FOOTER //
// ./src/global/breakpoints.js